module.exports = __webpack_public_path__ + "2843b9ed1ee4815fa575d9adbca4a0f7.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/companies/0C00003AU6.png
// module id = 1519
// module chunks = 0